import { collection } from "@doitintl/models-types";

@collection("rateLimits")
export class RateLimitsModel {
  attempts!: number[];
}
